// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-fluid[data-v-ec060866] {\n    margin-left: 0;\n}\n.col-form-label[data-v-ec060866] {\n    width: 80px;\n}\n.fixed-bottom[data-v-ec060866] {\n    padding: 4px 0;\n}\n\n", ""]);
// Exports
module.exports = exports;
